import { HostBinding, Input, Directive, EventEmitter, HostListener, Output } from "@angular/core";
import * as ɵngcc0 from '@angular/core';
var SuiTabHeader = /** @class */ (function () {
    function SuiTabHeader() {
        this._isActive = false;
        this.isActiveChange = new EventEmitter();
        this.isActiveExternalChange = new EventEmitter();
        this.onActivate = new EventEmitter();
        this.onDeactivate = new EventEmitter();
        this.isDisabled = false;
        this._headerClasses = true;
    }
    Object.defineProperty(SuiTabHeader.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        set: function (active) {
            var _this = this;
            var isActive = active;
            // Only used by @Input(), runs whenever user input changes `isActive`.
            // Run in timeout because `isDisabled` can prohibit user from changing `isActive`.
            // so update is delayed to avoid 'changed after checked' error.
            setTimeout(function () {
                // Only allow change if tab header is not disabled.
                isActive = !_this.isDisabled ? active : false;
                _this.setActiveState(isActive);
                // Fire 'external change' event as user input has occured.
                // Fire 'external change' event as user input has occured.
                _this.isActiveExternalChange.emit(isActive);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiTabHeader.prototype, "isDisabled", {
        get: function () {
            return this._isDisabled;
        },
        set: function (disabled) {
            // Only update if value provided is different to current one.
            if (this._isDisabled !== disabled) {
                this._isDisabled = disabled;
                // If now disabled, then tab header must be deactivated.
                if (this.isDisabled) {
                    this.isActive = false;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    // Internally update active state.
    // Internally update active state.
    SuiTabHeader.prototype.setActiveState = 
    // Internally update active state.
    function (active) {
        // If (cast) active value has changed:
        if (!!this._isActive !== active) {
            // Update to the new value.
            this._isActive = active;
            // Fire the appropriate activation event.
            if (active) {
                this.onActivate.emit();
            }
            else {
                this.onDeactivate.emit();
            }
        }
        // Regardless, emit a change to `isActive`, so [(isActive)] works correctly.
        this.isActiveChange.emit(active);
    };
    SuiTabHeader.prototype.onClick = function () {
        if (!this.isDisabled) {
            // Activate the tab when clicked, so long as it isn't disabled.
            this.isActive = true;
        }
    };
    /** @nocollapse */
    SuiTabHeader.ctorParameters = function () { return []; };
    SuiTabHeader.propDecorators = {
        "_headerClasses": [{ type: HostBinding, args: ["class.item",] },],
        "id": [{ type: Input, args: ["suiTabHeader",] },],
        "isActiveChange": [{ type: Output },],
        "onActivate": [{ type: Output, args: ["activate",] },],
        "onDeactivate": [{ type: Output, args: ["deactivate",] },],
        "isActive": [{ type: HostBinding, args: ["class.active",] }, { type: Input },],
        "isDisabled": [{ type: HostBinding, args: ["class.disabled",] }, { type: Input },],
        "onClick": [{ type: HostListener, args: ["click",] },],
    };
SuiTabHeader.ɵfac = function SuiTabHeader_Factory(t) { return new (t || SuiTabHeader)(); };
SuiTabHeader.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SuiTabHeader, selectors: [["", "suiTabHeader", ""]], hostVars: 6, hostBindings: function SuiTabHeader_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SuiTabHeader_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("disabled", ctx.isDisabled)("item", ctx._headerClasses)("active", ctx.isActive);
    } }, inputs: { isDisabled: "isDisabled", isActive: "isActive", id: ["suiTabHeader", "id"] }, outputs: { isActiveChange: "isActiveChange", onActivate: "activate", onDeactivate: "deactivate" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiTabHeader, [{
        type: Directive,
        args: [{
                selector: "[suiTabHeader]"
            }]
    }], function () { return []; }, { isActiveChange: [{
            type: Output
        }], onActivate: [{
            type: Output,
            args: ["activate"]
        }], onDeactivate: [{
            type: Output,
            args: ["deactivate"]
        }], isDisabled: [{
            type: HostBinding,
            args: ["class.disabled"]
        }, {
            type: Input
        }], _headerClasses: [{
            type: HostBinding,
            args: ["class.item"]
        }], isActive: [{
            type: HostBinding,
            args: ["class.active"]
        }, {
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ["click"]
        }], id: [{
            type: Input,
            args: ["suiTabHeader"]
        }] }); })();
    return SuiTabHeader;
}());
export { SuiTabHeader };

